<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/save-for-later/shared/save-for-later/save-for-later.component.ts
-->
<ng-template #anchor></ng-template>
